function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnicianMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 267 267",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.55556,0,0,5.55556,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0.5C14.91,0.5 7.55,7.86 7.55,16.95C7.55,29.29 24,47.5 24,47.5C24,47.5 40.45,29.29 40.45,16.95C40.45,7.86 33.09,0.5 24,0.5Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,19.54C26.53,19.54 28.58,17.56 28.72,15.06L19.29,15.06C19.42,17.55 21.48,19.54 24.01,19.54L24,19.54Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,21.91C20.84,21.91 14.54,23.49 14.54,26.64L14.54,29L33.46,29L33.46,26.64C33.46,23.5 27.16,21.91 24,21.91Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.28,8.1C28.01,9.1 28.89,10.54 29,12.45C29.15,12.5 29.35,12.5 29.43,12.59C29.61,12.82 29.88,13.12 29.85,13.35C29.82,13.58 29.47,13.78 29.23,13.96C29.14,14.02 28.98,13.98 28.85,13.98L19.18,13.98C18.7,13.98 18.23,13.94 18.17,13.33C18.11,12.74 18.52,12.55 19.05,12.47C19.11,11.27 19.46,10.17 20.29,9.28C20.71,8.84 21.21,8.47 21.76,8C21.92,8.85 22.02,9.53 22.19,10.2C22.24,10.39 22.48,10.54 22.63,10.7C22.72,10.5 22.91,10.28 22.89,10.09C22.82,9.4 22.72,8.72 22.55,8.05C22.4,7.44 22.74,7.23 23.2,7.18C23.73,7.12 24.28,7.13 24.82,7.17C25.39,7.21 25.59,7.5 25.49,8.07C25.38,8.75 25.24,9.43 25.16,10.12C25.14,10.3 25.31,10.51 25.39,10.7C25.55,10.55 25.82,10.43 25.87,10.25C26.04,9.57 26.15,8.87 26.29,8.09L26.28,8.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicianMarker);
export default __webpack_public_path__ + "static/media/TechnicianMarker.ba9cc9126840142df14fc2aa45b03be2.svg";
export { ForwardRef as ReactComponent };